import { defineStore } from "pinia"
import { computed, ref } from "vue"

export const useBrowserStore = defineStore("browser", () => {
  const fontSize = ref(10)
  const setFontSize = (size) => {
    fontSize.value = size
  }

  const windowWidth = ref(1)
  const windowHeight = ref(1)
  const setWindowSize = (width, height) => {
    windowWidth.value = width
    windowHeight.value = height
  }

  const lvw = ref(1)
  const lvh = ref(1)
  const setLargeViewportSize = (width, height) => {
    lvw.value = width
    lvh.value = height
  }

  return {
    fontSize,
    setFontSize,

    windowWidth,
    windowHeight,
    setWindowSize,

    lvw,
    lvh,
    setLargeViewportSize,
  }
})
